export const PLAN_LIMITS = {
  free: {
    maxAgents: 3,
    monthlyTokens: 200000,
  },
  premium: {
    maxAgents: 15,
    monthlyTokens: 2000000,
  },
};
